import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ContadorContenidos } from '../model/detalle-solicitud';
import { Serie } from '../model/serie';
import { ValorCampoSerie } from '../model/valor-campo-serie';
import { FiltroDevolucion } from '../model/filtro-devolucion';
import { TemplateFieldsOrdered } from '../model/template-field';
import { of } from 'rxjs';

const API_VALORES_SERIES = '/Contents/AddingValues/{ID_SERIE}/{ID_SERVICIO}';
const API_CAMPOS_PRESTAMOS = '/Series/Prestamos/';
const PATH = '/Series';

@Injectable()
export class SeriesService {

  private cacheTemplateFieldsOrdered = new Map();

  constructor(
    private http: HttpClient
  ) { }


  addValores(idSerie: number, idServicio: number, valores: ValorCampoSerie[]): Observable<any> {
    return this.http.post<any>(environment.API_BASE + API_VALORES_SERIES
      .replace('{ID_SERIE}', '' + idSerie).replace('{ID_SERVICIO}', '' + idServicio), valores);
  }


  getCountPrestamosBySerieId(serieId: number, filtro: FiltroDevolucion): Observable<ContadorContenidos> {
    return this.http.post<ContadorContenidos>
      (environment.API_BASE + API_CAMPOS_PRESTAMOS + 'Count/' + serieId, filtro);
  }

  getSerieById(serieId: number): Observable<Serie> {
    return this.http.get<any>(environment.API_BASE + PATH + '/' + serieId)
          .pipe(map(serie => Serie.toModel(JSON.stringify(serie))));
  }

  getFieldsSerieOrdered(seriesId: number[]): Promise<TemplateFieldsOrdered[][]> {
    return new Promise<TemplateFieldsOrdered[][]>(resolve => {
      const seriesWithoutFields = seriesId.filter(serieId => !this.cacheTemplateFieldsOrdered.has(serieId));

      if (seriesWithoutFields && seriesWithoutFields.length > 0) {
        this.getFieldsSeries(seriesWithoutFields)
          .pipe(first()).subscribe((fieldsOrdered: TemplateFieldsOrdered[][]) => {
            if (fieldsOrdered.length == 0) {
              resolve(null);
             }
            fieldsOrdered.map((fieldOrdered: TemplateFieldsOrdered[]) => {
              const filtersOrdered = fieldOrdered.map(field => TemplateFieldsOrdered.toModel(JSON.stringify(field)));
              this.cacheTemplateFieldsOrdered.set(filtersOrdered[0].campo.idSerie, filtersOrdered);
              resolve(this.getSeriesIdInCache(seriesId));
            });
          });
      } else {
        resolve(this.getSeriesIdInCache(seriesId));
       }
    });
  }
  private getFieldsSeries(seriesId: number[]): Observable<TemplateFieldsOrdered[][]> {
    return this.http.post<any>(`${environment.API_BASE + PATH}/GetFieldsSeriesOrdered`, seriesId);
  }

  /*getFieldsSerieOrdered(seriesId: number[]): Observable<TemplateFieldsOrdered[][]> {

    const seriesWithoutFields = seriesId.filter(serieId => !this.cacheTemplateFieldsOrdered.has(serieId));

    if (seriesWithoutFields && seriesWithoutFields.length > 0) {
      const call = this.http.post<any>(`${environment.API_BASE + PATH}/GetFieldsSeriesOrdered`, seriesId)
        .pipe(map((fieldsOrdered: TemplateFieldsOrdered[][]) =>
          fieldsOrdered.map((fieldOrdered: TemplateFieldsOrdered[]) => {
            const filtersOrdered = fieldOrdered.map(field => TemplateFieldsOrdered.toModel(JSON.stringify(field)));
            this.cacheTemplateFieldsOrdered.set(filtersOrdered[0].campo.idSerie, filtersOrdered);
            return this.getSeriesIdInCache(seriesId);
          }))
        );
      return;
    }

    return this.getSeriesIdInCache(seriesId);
  }*/
  private getSeriesIdInCache(seriesId: number[]): TemplateFieldsOrdered[][] {
    const series = seriesId.map(serieId => this.cacheTemplateFieldsOrdered.get(serieId));
    return series;
  }

}
